module.exports = __webpack_public_path__ + "img/econtrol1280x854.718bb659.jpg";